/** @format */

import React, { useEffect } from "react";
import Title from "./mini-components/Title";
import { Link } from "react-scroll";
import ScrollReveal from "scrollreveal";
import downloadfile from "../assets/Plan&Drive_Portable.zip";

const Croix = () => (
  <svg
    className="w-6 h-6 text-red-500"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const Check = () => (
  <svg
    className="w-6 h-6 text-green-800"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5 13l4 4L19 7"
    />
  </svg>
);

const Button = ({ text, link }) => (
  <a
    href={link}
    className="text-white block w-full bg-green-800 hover:bg-green-900 focus:ring-4 focus:ring-blue-200 font-bold rounded-lg text-sm px-4 py-2.5 text-center dark:focus:ring-blue-900"
  >
    {text}
  </a>
);

const ButtonLink = ({ link }) => (
  <Link
    to={link}
    smooth={true}
    duration={500}
    className="text-white font-bold w-full bg-green-800 hover:bg-green-900 focus:ring-4 focus:ring-blue-200 rounded-lg text-sm px-4 py-2.5 text-center dark:focus:ring-blue-900 cursor-pointer mt-4 block"
  >
    Demander un devis
  </Link>
);

const Card = ({
  title,
  PCplanning,
  multiusers,
  mobile,
  vehicles,
  link,
  isButtonLink,
}) => (
  <div className="bg-gray-100 p-6 rounded-lg shadow-md reveal flex flex-col justify-between h-full gap-4">
    <h3 className="text-lg font-semibold text-black-800">{title}</h3>
    <ul className="mt-4 space-y-2 text-gray-700">
      <li className="flex items-center">
        {PCplanning ? <Check /> : <Croix />}
        <span className="ml-2">Planification PC</span>
      </li>
      <li className="flex items-center">
        {multiusers ? <Check /> : <Croix />}
        <span className="ml-2">Multi-utilisateurs</span>
      </li>
      <li className="flex items-center">
        {mobile ? <Check /> : <Croix />}
        <span className="ml-2">Version Mobile (Android)</span>
      </li>
      <li className="flex items-center">
        <span className="ml-8 font-bold">{vehicles}</span>
      </li>
    </ul>

    {/* Boutons */}
    {isButtonLink ? (
      <ButtonLink link="contact" />
    ) : (
      <Button text="Télécharger" link={link} />
    )}
  </div>
);

export default function Download() {
  useEffect(() => {
    const sr = ScrollReveal({
      origin: "bottom",
      distance: "30px",
      duration: 500,
      delay: 100,
      easing: "ease-in-out",
    });
    sr.reveal(".reveal", { interval: 100 });
  }, []);

  return (
    <div className="bg-white-100 relative">
      <section id="telechargements" className="w-11/12 mx-auto my-24 pt-4">
        <Title title="Téléchargement" textplacement="left" />

        <div id="detailed-pricing" className="w-full lg:w-4/6 mx-auto mt-12">
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-4">
            Téléchargez Plan&Drive pour votre système d'exploitation.
          </p>

          {/* Disposition mobile en cartes */}
          <div className="md:grid md:grid-cols-3 md:gap-6 flex flex-col gap-6">
            {/* Carte Gratuite */}
            <Card
              title="Gratuite"
              PCplanning={true}
              multiusers={false}
              mobile={false}
              vehicles="3 véhicules max"
              link={downloadfile}
              isButtonLink={false}
            />
            {/* Carte Cloud */}
            <Card
              title="Cloud"
              PCplanning={true}
              multiusers={true}
              mobile={false}
              vehicles="10 véhicules max"
              link="contact"
              isButtonLink={true}
            />

            {/* Carte Premium */}
            <Card
              title="Premium"
              PCplanning={true}
              multiusers={true}
              mobile={true}
              vehicles="Illimité"
              link="contact"
              isButtonLink={true}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
